import React from 'react';

import { hexToCssHex } from '../../../utils';
import Money from '../../../../components/Money';
import withExtensionContextConsumer from '../../../hoc/withExtensionContextConsumer';

/* eslint-disable react/prop-types */
const LoyaltyIndicator = ({
  loyaltyAmountGoal,
  loyaltyTransactionsGoal,
  isAmountBased,
  progress,
  extension = {},
}) => (
  <div className="c-loyalty-indicator">
    <div
      className="c-loyalty-indicator__progress"
      style={{ width: `${progress}%`, backgroundColor: hexToCssHex(extension.primaryColor) }}
    />
    <span className="c-loyalty-indicator__goal u-text-normal u-co-grey--light">
      {
        isAmountBased ? <Money noDecimalsIfInt>{loyaltyAmountGoal}</Money> : `${loyaltyTransactionsGoal} transactions`
      }
    </span>
  </div>
);

export default withExtensionContextConsumer(LoyaltyIndicator);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyUpdate/components/Indicator.jsx